import React, { useState } from 'react';
import UserManagementTopHeader from './components/UserManagementTopHeader';
import UserManagementSearchForm from './components/UserManagementSearchForm';
import UserManagementList from './components/UserManagementList';
import { UserManagementType } from '@/types/user';

const UserManagementPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<UserManagementType[]>([]);
  const [changeStatusUser, setChangeStatusUser] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <UserManagementTopHeader />
      <UserManagementSearchForm
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        setChangeStatusUser={setChangeStatusUser}
        onSearch={() => setSearchTrigger((prev) => prev + 1)}
      />
      <UserManagementList
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        changeStatusUser={changeStatusUser}
        searchTrigger={searchTrigger}
      />
    </>
  );
};

export default UserManagementPage;
